var App = App || {};

App.Community = (() => {
    'use strict';

    const init = (id) => {
        const widget = document.getElementById(id);
        const carousel = widget.querySelector('.splide');

        const splide = new Splide(carousel, {
            type: 'loop',
            arrows: {
                prev: `#${id}-prev`,
                next: `#${id}-next`
            },
            pagination: false,
            gap: '20px',
            mediaQuery: 'max',
            breakpoints: {
                991: {
                    destroy: true
                }
            }
        });

        splide.mount();
    };

    return {
        init: init
    };
})();
